import React from "react";
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import { useEffect, useState, useRef, useMemo, useCallback } from 'react'
import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import { AgGridReact} from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import AppLayout from './components/AppLayout';
//import 'ag-grid-enterprise';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import {
  Button,
  Flex,
  Heading,
  Text,
  TextField,
  View,
  withAuthenticator,
} from "@aws-amplify/ui-react";
import { type } from "@testing-library/user-event/dist/type";
import { printConsole } from "./lib/utility";

ModuleRegistry.registerModules([ExcelExportModule]);

const axios = require('axios');

const myAPI="mktappapi";
let path = '/strategy';

const mboum=require('mboummarketdatalib');

const MyPortfolio = ({ signOut }) => {

  console.log("Executing MyPortfolio");
  const navigate = useNavigate();

  let numberOfChecked=useRef(0);
  let deleteIds=useRef([]);
  const changedRows = useRef(new Map());

  //const [email, setEmail]=useState()
  let email=useRef();
  const [days, setDays]=useState();
  const [forceRender, setForceRender]=useState(false);
  const [daysOffset, setDaysOffset]=useState();
  const [minInterest, setMinInyerest]=useState();
  const [maxInterest, setMaxInterest]=useState();
  const [settingsStr, setSettingsStr]=useState({"days":"30","daysOffset":"10","minInterest":"0.7","maxInterest":"1.5"});
  const [data,setData]=useState();
  const [counter, setCounter]=useState(0);
  const [error,setError]=useState('');
  const [hide, setHide]=useState("hidden");
  const [submitted, setSubmitted]=useState(false);
  const [stocks, setStocks]=useState({});
  let calledGetMyTransactions = useRef(false);
  let displayMessage = useRef();

  let apiCalled=useRef(0);

  const getUserInfo = async () => {
    try {
      await console.log("Executing getUserInfo");
      await Auth.fetchAuthSession();
      // Retrieve the user's email address
      const user = await Auth.fetchUserAttributes();
      await console.log("getUserInfo : user = ",user);
      await console.log("getUserInfo : email = " + JSON.stringify(user.email));
      email.current = await user.email;
      await console.log("getUserInfo email = "+email.current);
      return "done";
    } catch (error) {
      await console.log("Error in getUserInfo: ", error);
      return "error";
    }
  };

  
  let initString="";

  //const [analysis, setAnalysis]=useState([]);
  let analysis=useRef([]);

  let recLst=[];
  let indRecLst=0;

  let maxChg="";
  let avgChg="";
  let wAvgChg="";
  let maxChgArrStr=[];
  let maxChgArrNum=[];
  let chgPercentCnt=0;
  let sumChgPercent=0;
  let wSumChgPercent=0;
  let wSum=0;
  let cnt33=0;
  let cnt66=0;
  let cnt100=0;
  let profitResponse="";
  let daysNowToExp = useRef();

  
  async function getMyTransactions(email) {
    await console.log("Executing getMyTransactions");
    await console.log("getMyTransactions : email = "+email);
    calledGetMyTransactions.current = true;
    path = '/gettransactions';

    var passApistr=path + "/" + email;
    console.log("passApiStr = "+passApistr);
    let apiResponse = await get({apiName:myAPI, path:passApistr}).response;
    Promise.resolve(apiResponse)
       .then(async () => {
         let response = await apiResponse.body.json();
         await console.log("getMyTransactions : response = " + JSON.stringify(response));
         await console.log(response);
         var count = Object.keys(response).length;
         await console.log("getMyTransactions : count = "+ count);
         if (count>0){
          analysis.current=[];
          for (var i=0; i<count; i++) {
            if (i==1){
              for (var j=0; j<response[i].length; j++) {
                var keys = Object.keys(response[i]);
                await console.log(keys[j] + " = " + response[i][j]);
                if (response[i][j]=="null") {
                  response[i][j]=0;
                }
              }
            }
            await console.log ("getMyTransactions : response[" + i + "] = " +JSON.stringify(response[i]));
            //await setAnalysis(oldArray => [...oldArray, JSON.stringify(response[i])]);
            
            analysis.current[i]=response[i];
          }
          await console.log("getMyTransactions : analysis.length = " +analysis.current.length);
         }
       })
       .then (async () => {
        await getLastSales()
        .then(() => {
          console.log ("getMyTransactions : symbolprices = ");
          console.log (symbolsprices.current);
          console.log ("getMyTransactions : analysis.current.length = " + analysis.current.length);
          console.log ("getMyTransactions : symbolsprices.current.length = " + symbolsprices.current.length);
          console.log ("getMyTransactions : analysis.current = " , analysis.current);
          for (var analInd = 0; analInd < analysis.current.length; analInd ++){
            for (var symInd = 0; symInd < symbolsprices.current.length; symInd++) {
              var keys = Object.keys(symbolsprices.current[symInd]);
              var symInSymPrices = keys[0].toString();
              var symInAnalysis = analysis.current[analInd]["symbol"].toString();
              if (symInSymPrices === symInAnalysis) {
                analysis.current[analInd]["lastSale"] = symbolsprices.current[symInd][[symInSymPrices]];
                console.log ("getMyTransactions : update " + symInAnalysis + " lastSale = " + analysis.current[analInd]["lastSale"]);
                symInd = symbolsprices.current.length;
              }
            }
          }
        })
      })
      .then(() => {
        loadRowData();
      })
       .catch(error => {
         console.log(error)
       })
  }

  
let rowdata=[];
const [rowDataState,setRowDataSate]=useState([]);

  function loadRowData() {
    console.log ("Executing loadRowData");
    console.log ("loadRowData : analysis = "+ JSON.stringify(analysis));
    var buyWriteCost, premium, maxProfit, breakEven, daysNowToExp, optionPrice, pnl, pnlProfit;
    if (typeof(analysis.current)!='undefined') {
      var key=0;
      //var count = Object.keys(analysis).length;
      var count=analysis.current.length;
      console.log ("loadRowData : analysis length= "+count);
      var rank=0;

      for (key=0; key<count; key++) {

        var buyWriteCost = parseFloat(analysis.current[key]["buyWriteCost"]);
        if (buyWriteCost==null) buyWriteCost=0;
        var premium = parseFloat(analysis.current[key]["premium"]);
        if (premium==null) premium=0;
        var maxProfit = parseFloat(analysis.current[key]["maxProfit"]);
        if (maxProfit==null) maxProfit=0;
        var breakEven = parseFloat(analysis.current[key]["breakEven"]);
        if (breakEven==null) breakEven=0;
        var downRisk = parseFloat(analysis.current[key]["downRisk"]);
        if (downRisk==null) downRisk=0;
        var shares = parseInt(analysis.current[key]["shares"]);
        if (shares==null) shares=0;
        var sharePrice = parseFloat(analysis.current[key]["sharePrice"]);
        if (sharePrice==null) sharePrice=0;
        var sharePriceActual = parseFloat(analysis.current[key]["sharePriceActual"]);
        if (sharePriceActual==null) sharePriceActual=0;
        var callPrice = parseFloat(analysis.current[key]["callPrice"]);
        if (callPrice==null) callPrice=0;
        var contractsNum = parseInt(analysis.current[key]["contractsNum"]);
        if (contractsNum==null) contractsNum=0;
        var daysToExp = parseInt(analysis.current[key]["daysToExp"]);
        if (daysToExp==null) daysToExp=0;
        var tradeDate = analysis.current[key]["tradeDate"];
        if (tradeDate==null) tradeDate=0;
        var email = analysis.current[key]["email"];
        if (email==null) email="";
        var optionPrice = parseFloat(analysis.current[key]["optionPrice"]);
        if (optionPrice==null) optionPrice=0;
        var pnl = parseFloat(analysis.current[key]["pnl"]);
        if (pnl==null) pnl=0;
        var profitActual = parseFloat(analysis.current[key]["profitActual"]);
        if (profitActual==null) profitActual=0;
        
        rowdata[key]={
          id: analysis.current[key]["id"],
          symbol: analysis.current[key]["symbol"],
          rank: analysis.current[key]["rank"],
          offer: parseFloat(analysis.current[key]["offer"]),
          exp: analysis.current[key]["exp"],
          strike: parseFloat(analysis.current[key]["strike"]),
          lastSale: parseFloat(analysis.current[key]["lastSale"]),
          max: parseFloat(analysis.current[key]["max"]),
          bid: parseFloat(analysis.current[key]["bid"]),
          ask: parseFloat(analysis.current[key]["ask"]),
          int: parseInt(analysis.current[key]["int"]),
          vol: parseInt(analysis.current[key]["vol"]),
          profit: parseFloat(analysis.current[key]["profit"]),
          annual: parseFloat(analysis.current[key]["annual"]),
          depth: parseFloat(analysis.current[key]["depth"]),
          wAvg: parseFloat(analysis.current[key]["wAvg"]),
          volatility: parseFloat(analysis.current[key]["volatility"]),
          volatilityPeriod: parseFloat(analysis.current[key]["volatilityPeriod"]),
          volMinPeriod: parseFloat(analysis.current[key]["volMinPeriod"]),
          volMaxPeriod: parseFloat(analysis.current[key]["volMaxPeriod"]),
          buyWriteCost: buyWriteCost,
          premium: premium,
          maxProfit: maxProfit,
          breakEven: breakEven,
          downRisk: downRisk,
          shares: shares,
          sharePrice: sharePrice,
          sharePriceActual: sharePriceActual,
          callPrice: callPrice,
          contractsNum: contractsNum,
          daysToExp: daysToExp,
          tradeDate: tradeDate,
          email: email,
          optionPrice: optionPrice,
          pnl: pnl,
          profitActual: profitActual
        }
      }
      console.log("loadRowData : typeof rowDataState = "+typeof(rowDataState));
      console.log("loadRowData : length rowDataState = "+rowDataState.length);
      console.log("loadRowData : count = "+count);
      console.log("loadRowData : rowDataState.length = "+rowDataState.length);

      if (count !== 0) {//rowDataState.length < count &&  
        console.log("loadRowData : setting rowDataState");
        setRowDataSate(rowdata);
        console.log("loadRowData : rowdata = " + JSON.stringify(rowdata[0]));
      }
      
    }
  }

  const rowClassRules = {

    // row style function
    'goodOption': function(params) {
      console.log ("Executing goodOption");
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("goodOption : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      console.log("goodOption : dtNow = " + dtNow + "\tdtExp = " + dtExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : goodOption : daysNowToExp = "+expDays  + "\tsymbol = " + params.data["symbol"]);
      console.log("rowClassRules : params = ");
      let lastSale = parseFloat(params.data["lastSale"]);
      let strike = parseFloat(params.data["strike"]);
      let diffLastSaleVsStrike;
      if (lastSale < strike) {
        diffLastSaleVsStrike = -1;
      } else {
        diffLastSaleVsStrike = 1 - strike / lastSale
      }
      console.log(params);
      var depth = params.data["depth"];
      console.log("rowClassRules : depth = "+depth);
      var profit = params.data["profit"];
      console.log("rowClassRules : profit = "+profit);
      var adjProfit=parseFloat(profit)*30/expDays;
      console.log("rowClassRules : adjusted profit = "+(parseFloat(profit)*30/expDays));
      var maxChange = params.data["maxChange"];
      console.log("rowClassRules : maxChange = "+maxChange);
      var wAvgChange=params.data["wAvg"];
      console.log("rowClassRules : wAvgChange = "+wAvgChange);
      var minDepth=parseFloat(wAvgChange)*0.75
      console.log("rowClassRules : minDepth = "+minDepth);
      if (adjProfit >= 0.90 && depth >= minDepth) {
        console.log ("rowClassRules : goodOption : adjProfit = " + adjProfit + " --- profit = "+ profit + " --- depth = " + depth + " --- minDepth = " + minDepth);
      }
      return diffLastSaleVsStrike >= 0.05 && expDays >= 0;
    },
    'mediumOption': function (params) {
      console.log ("Executing medium");
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("medium : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : mediumOption : daysNowToExp = "+expDays + "\tsymbol = " + params.data["symbol"]);
      console.log("rowClassRules : params = ");
      let lastSale = parseFloat(params.data["lastSale"]);
      let strike = parseFloat(params.data["strike"]);
      let diffLastSaleVsStrike;
      if (lastSale < strike) {
        diffLastSaleVsStrike = -1;
      } else {
        diffLastSaleVsStrike = 1 - strike / lastSale
      }
      console.log(params);
      var depth = params.data["depth"];
      console.log("rowClassRules : depth = "+depth);
      var profit = params.data["profit"];
      console.log("rowClassRules : profit = "+profit);
      var adjProfit=parseFloat(profit)*30/expDays;
      console.log("rowClassRules : adjusted profit = "+(parseFloat(profit)*30/expDays));
      var maxChange = params.data["maxChange"];
      console.log("rowClassRules : maxChange = "+maxChange);
      var wAvgChange=params.data["wAvg"];
      console.log("rowClassRules : wAvgChange = "+wAvgChange);
      var minDepth=parseFloat(wAvgChange)*0.75
      console.log("rowClassRules : minDepth = "+minDepth);
      if (adjProfit >= 0.6 && adjProfit < 0.90 && depth >= minDepth) {
        console.log ("rowClassRules : mediumOption : adjProfit = " + adjProfit + " --- profit = "+ profit + " --- depth = " + depth + " --- minDepth = " + minDepth);
      }
      return diffLastSaleVsStrike >=0 && diffLastSaleVsStrike < 0.05  && expDays >= 0;
    },
    // row style expression
    'badOptionPortfolio': function (params) {
      console.log ("Executing badOptionPortfolio");
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("badOptionPortfolio : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : mbadOptionPortfolio : daysNowToExp = "+expDays + "\tsymbol = " + params.data["symbol"]);
      console.log("rowClassRules : params = ");
      let lastSale = parseFloat(params.data["lastSale"]);
      let strike = parseFloat(params.data["strike"]);
      let diffLastSaleVsStrike;
      if (lastSale < strike) {
        diffLastSaleVsStrike = -1;
      } else {
        diffLastSaleVsStrike = 1 - strike / lastSale
      }
      console.log(params);
      var depth = params.data["depth"];
      console.log("rowClassRules : depth = "+depth);
      var profit = params.data["profit"];
      console.log("rowClassRules : profit = "+profit);
      var adjProfit=parseFloat(profit)*30/expDays;
      console.log("rowClassRules : adjusted profit = "+(parseFloat(profit)*30/expDays));
      var maxChange = params.data["maxChange"];
      console.log("rowClassRules : maxChange = "+maxChange);
      var wAvgChange=params.data["wAvg"];
      console.log("rowClassRules : wAvgChange = "+wAvgChange);
      var minDepth=parseFloat(wAvgChange)*0.75
      console.log("rowClassRules : minDepth = "+minDepth);
      if (adjProfit >= 0.6 && adjProfit < 0.90 && depth >= minDepth) {
        console.log ("rowClassRules : badOptionPortfolio : adjProfit = " + adjProfit + " --- profit = "+ profit + " --- depth = " + depth + " --- minDepth = " + minDepth);
      }
      return diffLastSaleVsStrike < 0  && expDays >= 0;
    },

};

let symbolsprices = useRef([]);
async function getLastSales (){
  await console.log("Executing getLastSales");
  await console.log ("getLastSales : analysis.current.length = " + analysis.current.length);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const activeSymbols = analysis.current
    .filter(item => {
      const expStr = item["exp"];
      if (!expStr) return false;
      const expDate = new Date(expStr);
      return expDate >= today;
    })
    .map(item => item["symbol"]);

  if (activeSymbols.length === 0) {
    await console.log("getLastSales : no active (non-expired) symbols, skipping");
    return;
  }

  let symbols = activeSymbols.join(",");

  await console.log("getLastSales : symbols = " + symbols);
  path = '/getsymbolsprices';
  let passApistr=path + "/" + symbols;
  await console.log("passApiStr = "+passApistr);
  const response = await get({
    apiName: myAPI,
    path: passApistr,
  }).response
  let resp = await response.body.json();
  await Promise.resolve(resp)
  .then (async () => {
    
    await console.log("getLastSales : received symbols prices = ");
    await console.log (resp);
    symbolsprices.current = resp;
  })
}
  
  
useEffect(()=>{
  console.log ("Executing useEffect");
  async function fetchData() {
    console.log ("fetchData goodOption");
    await getUserInfo();
    if (typeof(email.current)!='undefined' && !calledGetMyTransactions.current) {
      await getMyTransactions(email.current);
    };
  };
  fetchData();
  

},[submitted])

const gridRef = useRef();

const gridApi = useCallback(() => {
  console.log ("Executing gridApi");
  if (!gridRef.current.api) {
    console.log("!gridRef.current.api");
    return;
  }

  console.log("!gridRef.current.api");
  return gridRef.current.api.gridApi;
}, [gridRef]);

const setCellValue = (rowIndex, columnField, value) => {
  console.log ("Executing setCellValue");
  gridApi().setDataValue(rowIndex, columnField, value);
};

function getFormattedDate(date) {
  console.log ("Executing getFormattedDate");
  console.log("getFormattedDate: received date = "+date);
  if (typeof(date)!='undefined') {
    if (date.toString().length>0){
      //console.log("getFormattedDate : received date = "+ date.toString());
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
    
      console.log("getFormattedDate : returning date = "+ month + '/' + day + '/' + year);
    
      return month + '/' + day + '/' + year;
    } else {
      return "";
    }
  } else {
    return "";
  }
  
}

function currencyFormat(num) {
  console.log ("Executing currencyFormat");
  return parseFloat(num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')).toFixed(2);
}

function getFontSize() {
  console.log ("Executing getFontSize");
  const fontSize = window.getComputedStyle(document.querySelector('#my-element'), ':before').getPropertyValue('font-size');
  return fontSize;
}

//console.log ("font size = "+getFontSize());

const columns=[
  {headerName: "Id", field: "id", hide: true,},
  {headerName: "email", field: "email", hide: true, valueGetter : row => {
    var emailRow=email.current;
    row.data.email=emailRow;
    return emailRow;
  },},
  {headerName: "Delete", field: "save", pinned: true, headerCheckboxSelection: false, checkboxSelection: true, minWidth:10},
  {headerName: "Security", field: "symbol", sortable: true, filter: true, pinned: true, minWidth:10, resizable:true, editable: true,},
  {headerName: "Expiration", field: "exp", sortable: true, filter: 'agDateColumnFilter',minWidth:50, editable: true, resizable:true, valueGetter: row =>{
    console.log("row: exp org = "+row.data.exp.toString());
    if (row.data.exp.toString().indexOf("GMT")>0) {
      var expiration=row.data.exp;
      expiration=expiration.toString().replace("GMT","");
      console.log("row: expiration without GMT = "+expiration);
      expiration=getFormattedDate(new Date(expiration));
      console.log("row: expiration formatted = "+expiration.toString());
      row.data.exp=expiration
      return expiration;
    } else {
        return row.data.exp;
    }
  },},
  {headerName: "Current Last Sale", field: "lastSale", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, editable: false, resizable:true, cellRenderer: row =>{
    if (isNaN(row.data.sharePrice)) {
      row.data.lastSale=0;
      return row.data.lastSale;
    } else {
        return row.data.lastSale;
    }
  },},
  {headerName: "Strike Price", field: "strike", sortable: true, filter: 'agNumberColumnFilter',minWidth:50, editable: true, resizable:true, },
  {headerName: "Share Price", field: "sharePrice", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, editable: true, resizable:true, cellRenderer: row =>{
    if (isNaN(row.data.sharePrice)) {
      row.data.sharePrice=0;
      return row.data.sharePrice;
    } else {
        return row.data.sharePrice;
    }
  },},
  {headerName: "PnL Actual", field: "pnl", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  editable: true, resizable:true, valueGetter : row => {
    const optionPrice=parseFloat(row.data.optionPrice);
    var pnl=0;
    const sharePriceActual=parseFloat(row.data.sharePriceActual);
    const securityPrice=parseFloat(row.data.sharePrice);
    const callPrice=parseFloat(row.data.callPrice);
    const shares=parseInt(row.data.shares);
    if (sharePriceActual>0 && optionPrice>=0 && securityPrice>0 && callPrice>0 && shares>0) {
      pnl=(sharePriceActual-securityPrice+callPrice-optionPrice)*shares;
      pnl=Math.round(pnl*100)/100;
    }
    row.data.pnl=pnl;
    return pnl;
  },},
  {headerName: "Profit Actual %", field: "profitActual", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  editable: true, resizable:true, valueGetter : row => {
    const pnl=parseFloat(row.data.pnl);
    var profitActual=0;
    const buyWriteCost=parseFloat(row.data.buyWriteCost);
    if (pnl>0 && buyWriteCost>0) {
      profitActual=pnl/buyWriteCost;
      profitActual=Math.round(profitActual*1000)/10;
    }
    row.data.profitActual=profitActual;
    return profitActual;
  },},
  {headerName: "Annual Profit %", field: "annual", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  resizable:true, valueGetter : row => {
    console.log (row.data);
    var annualProfit=row.data.annual;
    var profit=parseFloat(row.data.profit);
    var daysToExpire=parseInt(row.data.daysToExp)
    if (profit>0 && daysToExpire>0) {
      annualProfit=profit/daysToExpire*360;
      console.log ("annualProfit % = "+annualProfit);
      annualProfit=Math.round(annualProfit*100)/100;
    }
    row.data.annual=annualProfit;
    return annualProfit;
  },},
  {headerName: "Days To Expire", field: "daysToExp", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  resizable:true, valueGetter : row => {
    var tradeDate=row.data.tradeDate;
    var expDate=row.data.exp;
    var daysToExpire=0
    
    if (tradeDate !== null && parseInt(tradeDate) !== 0 && expDate !== null ) {
      if (typeof(tradeDate) !=='undefined' && typeof(expDate) !== 'undefined') {
        var expDateTime=new Date(expDate);
        var tradeDateTime=new Date(tradeDate);
        var daysTime = expDateTime.getTime() - tradeDateTime.getTime();
        daysToExpire= parseInt(daysTime / (1000 * 3600 *24));
      }
    }
    row.data.daysToExp=daysToExpire;
    return daysToExpire;
  }, cellRenderer: row =>{
    if (isNaN(row.data.daysToExp)) {
      row.data.daysToExp=0;
      return row.data.daysToExp;
    } else {
        return row.data.daysToExp;
    }
  },},

  {headerName: "Shares", field: "shares", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, editable: true, resizable:true, cellRenderer: row =>{
    if (isNaN(row.data.shares)) {
      row.data.shares=0;
      return row.data.shares;
    } else {
        return row.data.shares;
    }
  },},
  {headerName: "Call Price", field: "callPrice", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, editable: true, resizable:true, cellRenderer: row =>{
    if (isNaN(row.data.callPrice)) {
      row.data.callPrice=0;
      return row.data.callPrice;
    } else {
        return row.data.callPrice;
    }
  },},
  {headerName: "Contracts Num", field: "contractsNum", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, editable: true, resizable:true, cellRenderer: row =>{
    if (isNaN(row.data.contractsNum)) {
      row.data.contractsNum=0;
      return row.data.contractsNum;
    } else {
        return row.data.contractsNum;
    }
  },},
  
  
  {headerName: "BuyWrite  Cost", field: "buyWriteCost", sortable: true, filter: 'agNumberColumnFilter',minWidth:50, resizable:true, valueGetter : row => {
    var buyWriteCost=0;
    const shares=row.data.shares;
    const securityPrice=row.data.sharePrice;
    const contractsNum=row.data.contractsNum;
    const callPrice=row.data.callPrice;
    if (shares>0 && securityPrice>0 & contractsNum>0 & callPrice>0) {
      buyWriteCost=shares * securityPrice - contractsNum * callPrice * 100;
      buyWriteCost=Math.round(buyWriteCost*100)/100
    }
    row.data.buyWriteCost=buyWriteCost;
    return buyWriteCost;
  },},
  {headerName: "Premium", field: "premium", sortable: true, filter: 'agNumberColumnFilter',minWidth:50, resizable:true, valueGetter : row => {
    var premium=0;
    const strike=parseFloat(row.data.strike);
    const securityPrice=parseFloat(row.data.sharePrice);
    const callPrice=parseFloat(row.data.callPrice);
    if (strike>0 && securityPrice>0 & callPrice>0) {
      premium=strike + callPrice - securityPrice;
      premium=Math.round(premium*100)/100;
    }
    row.data.premium=premium;
    return premium;
  },},
  {headerName: "Max Profit", field: "maxProfit", sortable: true, filter: 'agNumberColumnFilter',minWidth:50, resizable:true, valueGetter : row => {
    var maxProfit=0;
    const shares=row.data.shares;
    const premium=row.data.premium;
    if (shares>0 && premium>0 ) {
      maxProfit=shares * premium;
      maxProfit=Math.round(maxProfit*100)/100
    }
    row.data.maxProfit=maxProfit;
    return maxProfit;
  },},
  {headerName: "Profit %", field: "profit", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, resizable:true, valueGetter : row => {
    var profit=parseFloat(row.data.profit);
    const maxProfit=parseFloat(row.data.maxProfit);
    const buyWriteCost=parseFloat(row.data.buyWriteCost);

    if (maxProfit>0 && buyWriteCost>0) {
      profit=maxProfit/buyWriteCost;
      profit=Math.round(profit*10000)/100
    }
    row.data.profit=profit;
    return profit;
  },},
  {headerName: "Break Even", field: "breakEven", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, resizable:true, valueGetter : row => {
    var breakEven=0;
    const strike=parseFloat(row.data.strike);
    const premium=parseFloat(row.data.premium);
    if (strike > 0 && premium>0 ) {
      breakEven=strike - premium;
    }
    row.data.breakEven=breakEven;
    return breakEven;
  },},
  {headerName: "Down Risk", field: "downRisk", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, resizable:true, valueGetter : row => {
    var downRisk=0;
    const securityPrice=parseFloat(row.data.sharePrice);
    const breakEven=parseFloat(row.data.breakEven);
    if (securityPrice > 0 && breakEven>0 ) {
      downRisk=(securityPrice - breakEven)/securityPrice;
      console.log("downRisk = "+ downRisk);
      downRisk=Math.round(downRisk*10000)/100;
    }
    row.data.downRisk=downRisk;
    return downRisk;
  },},
  {headerName: "Trade Date", field: "tradeDate", sortable: true, filter: 'agDateColumnFilter', minWidth:50,  editable: true, resizable:true, valueGetter: row =>{
    if (parseInt(row.data.tradeDate) !== 0 && row.data.tradeDate !=='' && row.data.tradeDate !== null && typeof(row.data.tradeDate)!=='undefined' && !isNaN(row.data.tradeDate)) {
      console.log("condition 1 tradeDate = " + row.data.tradeDate);
      var tradeDate=row.data.tradeDate;
      tradeDate=tradeDate.toString().replace("GMT","");
      tradeDate=getFormattedDate(new Date(tradeDate));
      row.data.tradeDate=tradeDate
    } else {
        console.log("condition 2 row.data.tradeDate = " + row.data.tradeDate);
        var tradeDate=row.data.tradeDate;
        console.log("condition 2 tradeDate = " + tradeDate);
        try {
          tradeDate=tradeDate.toString();
          console.log('precondition 3 tradeDate.indexOf("NaN") = ' + tradeDate.indexOf("NaN"));
          if (tradeDate.indexOf("NaN")>0) {
            console.log("condition 3 tradeDate = " + tradeDate);
            row.data.tradeDate=0
          } /*else if (isNaN(row.data.tradeDate)) {
            console.log("condition 4 tradeDate = " + row.data.tradeDate);
            row.data.tradeDate=0
          }*/
        } catch (error) {
          
        }
    }
    console.log("return row.data.tradeDate = " + row.data.tradeDate);
    return row.data.tradeDate;
  }, cellRenderer: row =>{
    if (parseInt(row.data.tradeDate) !==0 ) {
      var tradeDate=row.data.tradeDate.toString();
      console.log("cellRenderer : tradeDate = " + tradeDate);
      tradeDate=tradeDate.replace("GMT","");
      tradeDate=new Date(tradeDate);
      tradeDate=getFormattedDate(tradeDate);
      row.data.tradeDate=tradeDate
      return row.data.tradeDate;
    } else {
        return row.data.tradeDate;
    }
  },},
  {headerName: "Share Price Actual", field: "sharePriceActual", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  resizable:true, editable: true,cellRenderer: row =>{
    if (isNaN(row.data.sharePriceActual)) {
      row.data.sharePriceActual=0;
      return row.data.sharePriceActual;
    } else {
        return row.data.sharePriceActual;
    }
  },},
  {headerName: "Option Price Actual", field: "optionPrice", sortable: true, filter: 'agNumberColumnFilter', minWidth:50,  editable: true, resizable:true, valueGetter : row => {
    var optionPrice=row.data.optionPrice;
    const sharePriceActual=parseFloat(row.data.sharePriceActual);
    const strike=parseFloat(row.data.strike);
    if (sharePriceActual>0 && strike>0) {
      optionPrice=sharePriceActual-strike;
      optionPrice=Math.round(optionPrice*100)/100;
    }
    row.data.optionPrice=optionPrice;
    return optionPrice;
  }, cellRenderer: row =>{
    if (isNaN(row.data.optionPrice)) {
      row.data.optionPrice=0;
      return row.data.optionPrice;
    } else {
        return row.data.optionPrice;
    }
  },}
];



const onSelectionChanged=() =>{
  console.log ("Executing onSelectionChanged");
  var commitDelete="";
  let selectedRowsNumber=gridRef.current.api.getSelectedRows().length;
  console.log("gridRef.current.api.getSelectedRows().length = " + selectedRowsNumber);
  /*if (gridRef.current.api.getSelectedRows().length>0) {
    commitDelete="commit";
  } else {
    commitDelete="delete";
  }*/
  if (selectedRowsNumber>=numberOfChecked.current) {
    commitDelete="delete";
    numberOfChecked.current++;
  } else {
    commitDelete="commit";
    numberOfChecked.current--;
  }

  console.log("commitDelete = "+commitDelete);
  //const selectedRows = gridRef.current.api.getSelectedRows();
  
  
  console.log("gridRef");
  console.log(gridRef);
  console.log("getSelectedNodes");
  console.log(gridRef.current.api.getSelectedNodes());
  if (gridRef.current.api.getSelectedNodes().length > 0) {
    console.log("checkboxSelected");
    console.log(gridRef.current.api.checkboxSelected);
    console.log("getDisplayedRowCount = "+gridRef.current.api.getDisplayedRowCount());
    const selectedRowIndex=gridRef.current.api.getFocusedCell().rowIndex;
    console.log("selectedRowIndex = "+selectedRowIndex);
    console.log("getDisplayedRowAtIndex");
    console.log(gridRef.current.api.getDisplayedRowAtIndex(selectedRowIndex));

    const selectedRows = gridRef.current.api.getDisplayedRowAtIndex(selectedRowIndex).data;
    console.log("selectedRows");
    console.log(selectedRows);

    let rowJson={"security":{}};
    let dt=Date().toString();
    let timestamp=Date.parse(dt).toString();
    for (i=0; i<selectedRows.length; i++) {
      if (typeof(selectedRows[i])=='undefined') {
        selectedRows[i]="";
      }
    }
    rowJson.security["id"]=selectedRows.id.toString();;
    rowJson.security["timestamp"]=dt;
    rowJson.security["symbol"]=selectedRows.symbol.toUpperCase();
    rowJson.security["rank"]=selectedRows.rank.toString();
    rowJson.security["offer"]=selectedRows.offer.toString();
    var exp=selectedRows.exp.toString();
    /*exp=new Date(exp).toString();
    var gmtpos=exp.search("GMT")+3;
    exp=exp.substring(0,gmtpos);
    var spacePos=exp.search(" ");
    exp=exp.replace(" ",", ");
    const expDt=new Date(exp);*/
    rowJson.security["exp"]=exp;
    rowJson.security["strike"]=selectedRows.strike.toString();
    rowJson.security["bid"]=selectedRows.bid.toString();
    rowJson.security["ask"]=selectedRows.ask.toString();
    rowJson.security["int"]=selectedRows.int.toString();
    rowJson.security["vol"]=selectedRows.vol.toString();
    rowJson.security["profit"]=selectedRows.profit.toString();
    try {
      rowJson.security["annual"]=selectedRows.annual.toString();
    } catch (e) {
    }
    
    rowJson.security["depth"]=selectedRows.depth.toString();
    rowJson.security["wavg"]=selectedRows.wAvg.toString();
    rowJson.security["max"]=selectedRows.max.toString();
    rowJson.security["volatility"]=selectedRows.volatility.toString();
    rowJson.security["volatilityPeriod"]=selectedRows.volatilityPeriod.toString();
    rowJson.security["volMinPeriod"]=selectedRows.volMinPeriod.toString();
    rowJson.security["volMaxPeriod"]=selectedRows.volMaxPeriod.toString();
    rowJson.security["email"]=email.current;

    if (commitDelete==="commit") {
      for (var i=0; i<deleteIds.current.length; i++) {
        if (deleteIds.current[i]["security"]["id"]===rowJson.security["id"]){
          deleteIds.current.splice(i,1);
          console.log("onSelectionChanged : deleteIds removed = "+ rowJson.security["id"]);
          console.log(deleteIds.current);
        }
      }
      path = '/storetransaction';
      //var passApistr=path + "/" + JSON.stringify(rowJson);
      let transaction = new URLSearchParams({ data: JSON.stringify(rowJson) }).toString();
      transaction = transaction.replace("data=","");
      transaction = transaction.replace(/"%3A"/g,/":"/)
      let passApistr=path + "/" + transaction;
      console.log("onSelectionChanged : passApistr = " +passApistr);
      /*get({apiName:myAPI, path:passApistr}).response
        .then(async resp =>{
          await console.log("onSelectionChanged : resp = ");
          await console.log(resp);
        })*/
      /*get({
        apiName: myAPI,
        path: passApistr,
      }).response
        .then(async resp =>{
          await console.log("onSelectionChanged : resp = ", resp);
        })
        .catch(error => {
          console.log(error.message);
          //errorState.current = true;
          //setDisplayMessage(error.message);
        })*/
    }

    if (commitDelete==="delete") {
      deleteIds.current[deleteIds.current.length]=rowJson;
      //console.log("onSelectionChanged : deleteIds added = "+ rowJson.security["id"]);
      //console.log(deleteIds.current);
      path = '/deletetransaction';
      //var passApistr=path + "/" + JSON.stringify(rowJson);
      let transaction = new URLSearchParams({ data: JSON.stringify(rowJson) }).toString();
      transaction = transaction.replace("data=","");
      transaction = transaction.replace(/"%3A"/g,/":"/)
      let passApistr=path + "/" + transaction;
      //var passApistr=path + "/" + JSON.stringify(rowJson);
      console.log("onSelectionChanged : passApistr = " +passApistr);
      /*get({apiName:myAPI, path:passApistr}).response
        .then(async resp =>{
          await console.log("onSelectionChanged : resp = ");
          await console.log(resp);
        })*/
      /*get({
        apiName: myAPI,
        path: passApistr,
      }).response
        .then(async resp =>{
          await console.log("onSelectionChanged : resp = ", resp);
        })
        .catch(error => {
          console.log(error.message);
          //errorState.current = true;
          //setDisplayMessage(error.message);
        })*/
    }
  }
}

function addEmptyRow() {
  console.log ("Executing addEmptyRow");
  const nowTimestamp=Date.now();
  const emptyRowData = [{
    id: nowTimestamp,
    email: email.current,
    symbol: "",
    buyWriteCost: 0,
    premium: 0,
    maxProfit: 0,
    breakEven: 0,
    downRisk: 0,
    shares: 0,
    sharePriceActual: 0,
    lastSale: 0,
    callPrice: 0,
    contractsNum: 0,
    daysToExp: 0,
    tradeDate: 0,
    optionPrice: 0,
    pnl: 0,
    profitActual: 0,
    rank: 0,
    offer: 0,
    exp: "",
    strike: 0,
    max: 0,
    bid: 0,
    ask: 0,
    int: 0,
    vol: 0,
    profit: 0,
    annual: 0,
    depth: 0,
    wAvg: 0,
    volatility: 0,
    volatilityPeriod: 0,
    volMinPeriod: 0,
    volMaxPeriod: 0,
  }];
  gridRef.current.api.applyTransaction({ add: emptyRowData });
}

function deleteOneRec(passApistr, i) {
  console.log ("Executing deleteOneRec");
  console.log("deleteRecs : passApistr = " + passApistr);
  console.log("received i = "+ i);
  let apiResponse = get({apiName:myAPI, path:passApistr}).response;
  Promise.resolve(apiResponse)
  .then(() =>{
      let resp = apiResponse.body.json();
      console.log("deleteRecs : resp = ");
      console.log(resp);
      //console.log("grid data row 5");
      //console.log(gridRef.current.api.getDisplayedRowAtIndex(8));
      var respStr=resp.toString();
      var removeRow=[];
      if (respStr.indexOf("Could not delete the record")<0) {
        console.log ("Grid number of rows = " + gridRef.current.api.getDisplayedRowCount());
        console.log("i = "+ i);
        console.log(deleteIds.current);
        for(var j=0; j<gridRef.current.api.getDisplayedRowCount(); j++) {
          if (deleteIds.current[i].security.id == gridRef.current.api.getDisplayedRowAtIndex(j).data.id) {
            try {
              removeRow[0] = gridRef.current.api.getDisplayedRowAtIndex(j).data; 
              console.log(removeRow);
              gridRef.current.api.applyTransaction({ remove: removeRow });
            } catch (error) {
              console.log(error);
            }
            
          }
        }
      }
  })
}

async function deleteRecServer(passApistr, i, arrOfIds) {
  await console.log ("Executing deleteRecServer");
  await console.log("arrayOfIds below ");
  await console.log(arrOfIds);
  await console.log("deleteRecs : passApistr = " + passApistr);
  await console.log("received i = "+ i);
  let apiResponse = await get({apiName:myAPI, path:passApistr}).response;
  await console.log("apiResponse below");
  Promise.resolve(apiResponse)
  .then(async () =>{
      await console.log("deleteRecServer: apiResponse = ", apiResponse);
      let resp = await apiResponse.body.text();
      await console.log("deleteRecs : resp = ");
      await console.log(resp);
      //console.log("grid data row 5");
      //console.log(gridRef.current.api.getDisplayedRowAtIndex(8));
      var respStr=resp.toString();
      var removeRow=[];
      if (respStr.indexOf("Could not delete the record")<0) {
        await console.log ("Grid number of rows = " + gridRef.current.api.getDisplayedRowCount());

        await console.log(deleteIds.current);
        for (var i=0; i<deleteIds.current.length; i++) {
          for(var j=0; j<gridRef.current.api.getDisplayedRowCount(); j++) {
            try {
              if (deleteIds.current[i].security.id == gridRef.current.api.getDisplayedRowAtIndex(j).data.id) {
              
                removeRow[0] = gridRef.current.api.getDisplayedRowAtIndex(j).data; 
                await console.log("before removing row "+j);
                await console.log(removeRow);
                gridRef.current.api.applyTransaction({ remove: removeRow });
                await console.log("gridRef.current.api.getDisplayedRowAtIndex(" + j + ") = ", gridRef.current.api.getDisplayedRowAtIndex(j));
                removeRow[0] = gridRef.current.api.getDisplayedRowAtIndex(j).data; 
                await console.log("after removing row "+j);
                await console.log(removeRow);
              }
            } catch (error) {
              await console.log(error);
            }
          }
        }
        deleteIds.current=[];
      }
  })
}

async function deleteRecs() {
  await console.log ("Executing deleteRecs");
  if (deleteIds.current.length>0) {
    await console.log(deleteIds);
    var arrOfIds=[]
    path = '/deletetransaction';
    var passApistr="";
    for (var i=0; i<deleteIds.current.length; i++) {
      var exp=convertDate(deleteIds.current[i].security.exp);
      deleteIds.current[i].security.exp=exp;
      await console.log(deleteIds);
      arrOfIds[i]=deleteIds.current[i].security.id;
      var passApistr=path + "/" + JSON.stringify(deleteIds.current[i]);

      //deleteOneRec(passApistr, i)
    
    }
    var passApistr=path + "/" + arrOfIds.toString();
    await deleteRecServer(passApistr, i, arrOfIds);
  }
}
async function deleteRowDataState(){
  await console.log("Executing deleteRowDataState");
  await setRowDataSate([]);
  await console.log("deleteRowDataState : rowDataState.length = "+ rowDataState.length);
};

function convertDate(dt) {
  console.log ("Executing convertDate");
  var dtDate=new Date(dt);
  var dtDayOfWeekNum=dtDate.getDay();
  var dtDayOfWeek="";

  if (dtDayOfWeekNum==0){
    dtDayOfWeek="Sun";
  }
  if (dtDayOfWeekNum==1){
    dtDayOfWeek="Mon";
  }
  if (dtDayOfWeekNum==2){
    dtDayOfWeek="Tue";
  }
  if (dtDayOfWeekNum==3){
    dtDayOfWeek="Wed";
  }
  if (dtDayOfWeekNum==4){
    dtDayOfWeek="Thu";
  }
  if (dtDayOfWeekNum==5){
    dtDayOfWeek="Fri";
  }
  if (dtDayOfWeekNum==6){
    dtDayOfWeek="Sat";
  }

  var dtMonthNum=dtDate.getMonth();
  var dtMonth="";
  var months=["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  for (var i=0; i<12; i++) {
    if (i==dtMonthNum) {
      dtMonth=months[i];
    }
  }
 
  var dtDay=dtDate.getDate().toString();
  var dtYear=dtDate.getFullYear().toString();
  var dtStr=dtDayOfWeek + ", " + dtDay + " " + dtMonth + " " + dtYear + " 00:00:00 GMT";

  return dtStr;
}

async function storeRec(jsonData) {
  console.log ("Executing storeRec");
  //jsonData.exp=jsonData.exp.toString().replace(/\//g, "%2F");
  jsonData.email=email.current;
  //var jsonDataStr=JSON.stringify(jsonData);
  //jsonDataStr=jsonDataStr.replace("stockOffer", "offer");
  //jsonDataStr=jsonDataStr.replace("expiration", "exp");
  //jsonData=JSON.parse(jsonDataStr);
  /*var sym=jsonData.security.toString();
  console.log("exp = " + exp);
  console.log("symbol = " + sym);
  var ask=jsonData.offer.toString();
  jsonData.ask=ask;
  jsonData.symbol=sym;
  jsonData.exp=exp;*/

  const orgExp=jsonData.exp.toString();
  const orgSymbol=jsonData.symbol.toString();

  await console.log("storeRec : delete = ");
  await console.log (jsonData);

  if (orgSymbol.length>0 && orgExp.length>0){

    var exp=await convertDate(jsonData.exp.toString());
    jsonData.exp=exp;

    try {
      tradeDate=jsonData.tradeDate;
      if (parseInt(tradeDate) !== 0) {

        var tradeDate=await convertDate(jsonData.tradeDate.toString());
        jsonData.tradeDate=tradeDate;
      }
    } catch (error) {
      
    }

    jsonData={"security":jsonData};

    var param = JSON.stringify(jsonData);
    await console.log("storeRec : param before encoding = "+param);
    param=encodeURI(param);
    await console.log("storeRec : param after encoding = "+param);
    jsonData.security.exp=jsonData.security.exp.toString().replace(/\//g, "%2F");
    path = '/storetransaction';
      var passApistr=path + "/" + param //JSON.stringify(jsonData);
      await console.log("storeRec : passApistr = " +passApistr);
      let apiResponse = await get({apiName:myAPI, path:passApistr}).response;
      Promise.resolve(apiResponse)
        .then(async () =>{
          let resp = await apiResponse.body.json();
          await console.log("storeRec : resp = ",resp);
        })
  }
}

async function storeLoopRecs() {
  await console.log ("Executing storeLoopRecs");
  displayMessage.current = "Updating portfolio";
  await console.log ("storeLoopRecs : gridRef = ", gridRef);
  var numOfRecs=gridRef.current.api.getDisplayedRowCount();

  let displayedRows = [];
  for (let rowInd =0; rowInd < numOfRecs; rowInd++) {
    displayedRows[rowInd] = gridRef.current.api.getDisplayedRowAtIndex(rowInd).data;
  }
  console.log ("storeLoopRecs : displayedRows = ", displayedRows);

  await console.log ("storeLoopRecs : numOfRecs = ", numOfRecs);
  var i, j;
  var deleteIdMatch=false;
  await console.log("storeLoopRecs : numOfRecs = " +numOfRecs);
  //for (i=0;i<numOfRecs;i++) {
  for (const [rowId, rowData] of changedRows.current.entries()) {
    await console.log("storeLoopRecs: Processing changed row", rowId, rowData);
    try {
      //await console.log ("storeLoopRecs : gridRef.current.api.getDisplayedRowAtIndex(" + i + ") =", gridRef.current.api.getDisplayedRowAtIndex(i).data);
    } catch (error) {
      await console.log ("gridRef.current = ",gridRef.current);
      //await console.log ("storeLoopRecs : error : gridRef.current.api.getDisplayedRowAtIndex : i = " + i);
    };
    deleteIdMatch=false;
    /*await console.log ("storeLoopRecs : deleteIds.current = ", deleteIds.current);
    for(j=0; j<deleteIds.current.length; j++) {
      //if (gridRef.current.api.getDisplayedRowAtIndex(i).data.id == deleteIds.current[j]) {
      if (displayedRows[i].id == deleteIds.current[j]) {
        deleteIdMatch=true;
        j=deleteIds.current.length;
      }
    }*/
    await console.log ("storeLoopRecs : deleteIdMatch = " + deleteIdMatch);
    if (!deleteIdMatch){
      try {
        //await storeRec(gridRef.current.api.getDisplayedRowAtIndex(i).data)
        //await console.log ("storeLoopRecs : displayedRows[i] = ", displayedRows[i]);
        //await storeRec(displayedRows[i])
        await storeRec(rowData)
        .then (async () => {
          await console.log ("storeLoopRecs : after storeRec : completed");
        })
      } catch (error) {};
    }
  }
  displayMessage.current = "";
}

const onCellValueChanged = (params) => {
  console.log("Cell value changed", params);
  const { data } = params; // Get the changed row data

  // Update the map of changed rows
  changedRows.current.set(data.id, data);

  console.log("Changed rows:", Array.from(changedRows.current.values()));
};

async function commitChanges() {
  await console.log ("Executing commitChanges");
  await console.log("Changed rows:", Array.from(changedRows.current.values()));
  await console.log (gridRef);
  await console.log (gridRef.current.api.getDisplayedRowCount());
  var numOfRecs=gridRef.current.api.getDisplayedRowCount();
  var i;
  await console.log("numOfRecs = " +numOfRecs);
  await deleteRecs()
  .then (async () => {

    await setTimeout(async () => {
      /*deleteRowDataState().then(()=>{
        console.log("commitChanges : rowDataState.length = "+ rowDataState.length);
        
      })*/
      /*for (i=0;i<numOfRecs;i++) {
        console.log (gridRef.current.api.getDisplayedRowAtIndex(i).data);
        storeRec(gridRef.current.api.getDisplayedRowAtIndex(i).data)
      }*/
      
      await deleteRowDataState().then(async(result)=>{
        await console.log("commitChanges : rowDataState.length = "+ rowDataState.length);
      }).then(async(res)=>{
        await console.log("will run storeRec");
        /*await storeLoopRecs().then(async ()=>{
          await getMyTransactions(email.current);
        })*/

        await storeLoopRecs()
        .then (async () => {
          await getMyTransactions(email.current)
          .then (async (resp) => {
            await console.log ("commitChanges : getMyTransactions : resp = ", resp);
          })
        })
        

        /*for (i=0;i<numOfRecs;i++) {
          await console.log (gridRef.current.api.getDisplayedRowAtIndex(i).data);
          await storeRec(gridRef.current.api.getDisplayedRowAtIndex(i).data)
        }
      
        await getMyTransactions(email.current);
        */
      })     
    }, 1000);

  })
}

function onFirstDataRendered(params) {
  console.log ("Executing onFirstDataRendered");
  //params.api.sizeColumnsToFit();
  console.log("onFirstDataRendered : params = ", params);
  var allColumnIds = [];
  params.api.getAllGridColumns().forEach(function(column) {
      allColumnIds.push(column.colId);
  });
  params.api.autoSizeColumns(allColumnIds);
}

  function onBtExport () {
    console.log ("Executing onBtExport");
    gridRef.current.api.exportDataAsCsv();;
  };

  return (
    <AppLayout signOut={signOut}>
      <div style={{ padding: '24px', width: '70%' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            My Portfolio
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.6)' }}>
            Manage your buy-write positions and track performance
          </p>
        </div>

        {/* Loading Message */}
        {displayMessage.current && (
          <div style={{
            padding: '12px',
            marginBottom: '16px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500'
          }}>
            {displayMessage.current}
          </div>
        )}

        {/* Portfolio Grid */}
        <div
          className="ag-theme-quartz"
          style={{
            height: 'calc(100vh - 360px)',
            width: '100%',
            '--ag-header-height': '48px',
            '--ag-row-height': '52px',
            '--ag-header-background-color': 'rgba(249, 250, 251, 1)',
            '--ag-odd-row-background-color': 'rgba(255, 255, 255, 1)',
            '--ag-row-background-color': 'rgba(255, 255, 255, 1)',
            '--ag-row-hover-color': 'rgba(59, 130, 246, 0.05)',
            '--ag-border-color': 'rgba(229, 231, 235, 1)',
            '--ag-header-foreground-color': 'rgba(55, 65, 81, 1)',
            '--ag-foreground-color': 'rgba(17, 24, 39, 1)',
            '--ag-font-size': '14px',
            '--ag-cell-horizontal-padding': '16px',
            borderRadius: '8px',
            border: '1px solid rgba(229, 231, 235, 1)',
            marginBottom: '16px'
          }}
        >
          <AgGridReact
            rowClassRules={rowClassRules}
            rowData={rowDataState}
            columnDefs={columns}
            suppressRowClickSelection={true}
            rowSelection={'multiple'}
            ref={gridRef}
            onFirstDataRendered={onFirstDataRendered}
            onSelectionChanged={onSelectionChanged}
            onCellValueChanged={onCellValueChanged}
          />
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => { addEmptyRow(); }}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 6px rgba(16, 185, 129, 0.3)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(16, 185, 129, 0.3)';
            }}
          >
            Add Row
          </button>

          <button
            onClick={() => { commitChanges(); }}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(59, 130, 246, 0.3)';
            }}
          >
            Commit Changes
          </button>

          <button
            onClick={() => { onBtExport(); }}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 6px rgba(139, 92, 246, 0.3)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(139, 92, 246, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(139, 92, 246, 0.3)';
            }}
          >
            Export To CSV
          </button>
        </div>
      </div>
    </AppLayout>
  );
};

export default withAuthenticator(MyPortfolio);